import { getEpic } from './getEpic';
import { updateEpic } from './updateEpic';

export const epics = [getEpic, updateEpic];
